<template>
  <div class="ProgectMag">
    <el-container>
      <el-header>
        <div style="width: 100%; background: #d5e7ed">
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleTabClick"
            style="width: 100%"
          >
            <el-tab-pane label="全部" name="first"></el-tab-pane>
            <el-tab-pane label="待审核" name="second"></el-tab-pane>
            <el-tab-pane label="已通过" name="third"></el-tab-pane>
            <el-tab-pane label="已驳回" name="fourth"></el-tab-pane>
          </el-tabs>
        </div>
        <el-form ref="form" :model="Projectform" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="申请部门" label-width="120px">
                <el-cascader
                  v-model="Projectform.applyDeptId"
                  :options="subDeptList"
                  :props="defaultProps"
                  @change="handleChange"
                  placeholder="请选择"
                  @active-item-change="handleChange"
                  change-on-select
                  :editable="false"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目名称" label-width="120px">
                <el-input
                  v-model="Projectform.name"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属合同" label-width="120px">
                <el-input
                  v-model="Projectform.generalContractName"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="项目编号" label-width="120px">
                  <el-input
                    v-model="Projectform.serialNumber"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开工日期" label-width="120px">
                  <el-date-picker
                    v-model="Projectform.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="预计完工日期" label-width="120px">
                  <el-date-picker
                    v-model="Projectform.expectFinishDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请人" label-width="120px">
                  <el-input
                    v-model="Projectform.applyUserName"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 6 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="clearSearchConditions"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
             <el-button
              type="primary"
              v-if="btnAuthorize.manualGeneration.btnEnable"
              icon="el-icon-plus"
              @click="manualGeneration()"
              >手动生成</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.addBtn.btnEnable"
              icon="el-icon-plus"
              @click="createProject()"
              >新建</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              icon="el-icon-edit"
              @click="editProject()"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.delBtn.btnEnable"
              icon="el-icon-delete"
              @click="DelectProject()"
              >删除</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.callback.btnEnable"
              icon="el-icon-plus"
              @click="CallBackProject()"
              >撤回</el-button
            >
            <el-button
              title="导出当前列表查询出的数据，列表显示字段即为导出表格中数据字段。"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportCurrentList()"
              >导出</el-button
            >
            <el-button
              title="导出当前列表查询出的数据，列表显示字段即为导出表格中数据字段。"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportAllCurrentList()"
              >导出全部</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="projectDetail"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.column.property == 'address'">
                <div>
                  {{ scope.row["province"] }} {{ scope.row["city"] }}
                  {{ scope.row["area"] }} {{ scope.row[scope.column.property] }}
                </div>
              </div>
              <div v-else-if="scope.column.property == 'projectInfo'">
                <div>
                  {{ scope.row["projectInfo"].length>900?`${scope.row["projectInfo"].substring(0,800)}...`:scope.row["projectInfo"] }}
                </div>
              </div>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// import NewContractDialog from "./ContractDetail/NewContractDialog";
import {
  getContractCodeByUserCodeService, //获取下拉列表数据
  getProjectListServices, //获取项目列表数据
  CallBackOneProjectSevice, //撤回一条项目立项单
  exportAllProjectList, //导出项目列表数据
  exportProjectList, //根据查询条件导出项目
  exportExcelService2, //导出
  deleteOneProjectSevice, //删除一条项目立项单数据
  autoGenerateProjectDetailsData, //手动生成事前成本
} from "@/services/allContractServices";
import { recallApproveItemFun } from "@/page/approveComponents/approve";
import {
  getAreaGroup,
  getsubDeptService,
} from "../../services/sysSettingService";
import { numFilter } from "@/utils/filters";
export default {
  name: "ProgectMag",
  // components: {
  //   NewContractDialog
  // },
  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      editFlag: false, //跳新建修改页面标志
      activeName: "first",
      departMentList: [], //申请部门下拉框
      belongContractList: [], //所属合同下拉框
      ProjectNameList: [], //项目名称下拉框
      selectItems: [], //选中的数据
      category: "PROJECT_NAME", //下拉列表类型，默认为项目名称
      Projectform: {
        //查询条件form
        id: '',
        applyDeptId: "", //申请人部门
        applyUserId: "", //申请人ID
        applyUserName: "", //申请人姓名
        generalContractName: "", //总包合同名称
        name: "", //项目名称
        serialNumber: "", //项目编号
        approveStatus: "", //审批状态
        approveUserId: "", //当前审批人
        province: "", //省
        city: "", //城市
        area: "", //区
        address: "", //详细地址
        createTime: "", //城市
        expectAuditDate: "", //预计审计日期
        expectCompleteCheckDate: "", //预计竣工验收日期
        expectFinishCheckDate: "", //预计交工验收日期
        expectFinishDate: "", //预计完工日期
        generalContractAmount: "", //对应总包合同的金额
        generalContractId: "", //总包合同id
        profit: "", //项目利润
        projectInfo: "", //项目信息
        projectTypeCode: "", //项目类型编码
        projectTypeName: "", //项目类型名称
        startDate: "", //开工日期
        tabIndex: "0",
      },
      tableColumnDatas: [
        { class: "serialNumber", labelName: "项目编号", sortEnable: false },
        { class: "name", labelName: "项目名称", sortEnable: false },
        { class: "address", labelName: "项目地址", sortEnable: false },
        { class: "projectInfo", labelName: "项目信息", sortEnable: false },
        {
          class: "generalContractName",
          labelName: "所属合同",
          sortEnable: false,
        },
        { class: "startDate", labelName: "开工日期", sortEnable: false },
        {
          class: "expectFinishDate",
          labelName: "预计完工日期",
          sortEnable: false,
        },
        {
          class: "expectFinishCheckDate",
          labelName: "交工验收日期",
          sortEnable: false,
        },
        {
          class: "defectLiabilityDate",
          labelName: "缺陷责任期日期",
          sortEnable: false,
        },
        {
          class: "expectCompleteCheckDate",
          labelName: "竣工验收日期",
          sortEnable: false,
        },
        {
          class: "expectAuditDate",
          labelName: "预计审计日期",
          sortEnable: false,
        },
        { class: "expectFinishDate", labelName: "交付日期", sortEnable: false },
        { class: "applyUserName", labelName: "申请人", sortEnable: false },
        { class: "applyDeptName", labelName: "申请部门", sortEnable: false },
        { class: "approveStatusName", labelName: "状态", sortEnable: false },
        // { class: "contents", labelName: "备注", sortEnable: false }
      ],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      showAdvanceFilter: false, //是否展开高级搜索
      subDeptList: [], //子部门列表
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        callback: { key: "callback", btnEnable: false }, //撤回
        export: { key: "export", btnEnable: false }, //导出
        manualGeneration: { key: "manualGeneration", btnEnable: false }, //手动生成
      },
    };
  },
  // mounted() {
  //   this.initProjectList();
  // },
  methods: {
    onActive(menuCode) {
      // this.clearSearchConditions();
      this.Projectform.id= this.tabRouteParam?.id??'';
      this.activeName = "first";
      this.Projectform.tabIndex = "0";
      this.currentPage = 1;
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initProjectList();
      let pid = 0;
      this.getsubListData(pid);
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    //获取category下拉框数据
    getProjectCode(category) {
      let param = {};
      param.category = category;
      getContractCodeByUserCodeService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "PROJECT_NAME") {
              this.ProjectNameList = res.data; //项目名称
            } else if (category == "GENERAL_CONTRACT_NAME") {
              this.belongContractList = res.data; //所属合同名称
            } else {
              this.departMentList = res.data; //申请部门
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    selectGroup() {
      this.form.areaCodeList = "";
      this.form.buildCode = "";
      this.form.roomCode = "";
      this.buildings = [];
      this.rooms = [];
    },
    //查询项目列表 gaa 20200810
    initProjectList() {
      let param = {
        tabIndex: this.Projectform.tabIndex,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      for (let key in this.Projectform) {
        if (this.Projectform[key] !== "") {
          param[key] = this.Projectform[key];
        }
      }
      getProjectListServices(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.tableData = res.data;
            this.totalCount = res.total;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    //点击查询 gaa
    handleClick() {
      this.currentPage = 1;
      this.initProjectList(); //查询列表
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.Projectform) {
        if (key != "tabIndex") {
          this.Projectform[key] = "";
        }
      }
    }, //
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initProjectList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initProjectList();
    }, //
    handleSelectionChange(val) {
      if (val.length) {
        this.selectItems = val;
      }
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    projectDetail(row, column, cell, event) {
      this.bus.$emit("tabClose", "houseDeliveMgr");
      this.$nextTick(() => {
        this.bus.$emit("navMenuChange", {
          routeId: "houseDeliveMgr",
          routeParam: {
            id: row.id,
            routeId: "houseDeliveMgr",
          },
        });
      });
    },
    handleTabClick(tab, event) {
      this.currentPage = 1;
      switch (this.activeName) {
        case "first":
          this.Projectform.tabIndex = "0";
          break;
        case "second":
          this.Projectform.tabIndex = "1";
          break;
        case "third":
          this.Projectform.tabIndex = "2";
          break;
        case "fourth":
          this.Projectform.tabIndex = "3";
          break;
        default:
          this.Projectform.tabIndex = "0";
          break;
      }
      this.initProjectList();
    },

    //跳转到创建项目立项单界面
    createProject() {
      let memberData = {};
      memberData.editFlag = false; //新增标志为false
      memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "find-setting",
        routeParam: memberData,
      });
    },
    //跳转到修改项目立项单界面
    editProject() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.selectItems[0].approveStatus != 1 &&
        this.selectItems[0].approveStatus != 4
      ) {
        this.$alert("只有 撤回/驳回 状态的合同可以修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let memberData = {};
      memberData.editFlag = true; //编辑标志为true
      memberData.id = this.selectItems[0].id; //选中行
      memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "totalReVisitList",
        routeParam: memberData,
      });
    },

    //工程量清单
    openProjectList() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let memberData = {};
      memberData.id = this.selectItems[0].id; //单条项目编号
      memberData.generalContractName = this.selectItems[0].generalContractName; //总包合同名称
      memberData.name = this.selectItems[0].name; //项目名称
      memberData.projectTypeName = this.selectItems[0].projectTypeName; //项目类型
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "complaintReportingSta",
        routeParam: memberData,
      });
    },

    //手动生成
    manualGeneration() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let data = {};
      data.projectId = this.selectItems[0].id;
      this.$confirm("确认生成该项目的事前成本吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        autoGenerateProjectDetailsData(data.projectId)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("生成成功", "提示", {
                confirmButtonText: "确定",
              });
              // this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },

    //删除一条项目立项单
    DelectProject() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let param = {};
      param.delIds = this.selectItems[0].id;
      this.$confirm("确认删除该条项目立项单数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        deleteOneProjectSevice(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },

    //撤回项目立项单
    CallBackProject() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let param = {
        itemId: this.selectItems[0].id,
        type: "PROJECT",
      };
      param.projectId = this.selectItems[0].id;
      this.$confirm("确认撤回该条项目立项单数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(async () => {
        let res = await recallApproveItemFun(param);
        if (res && res.code == 10000000) {
          this.$message.success("撤回成功");
          this.handleClick();
        }
      });
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },

    //根据查询条件导出项目列表
    exportAllCurrentList() {
      let param = {};
      for (let key in this.Projectform) {
        if (this.Projectform[key] !== "") {
          param[key] = this.Projectform[key];
        }
      }
      exportProjectList(param)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },

    //导出项目列表
    exportCurrentList() {
      if (this.selectItems.length < 1) {
        this.$alert("请选择要导出的数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      param.exportIds = new Array();
      for (let i = 0; i < this.selectItems.length; i++) {
        param.exportIds[i] = this.selectItems[i].id;
      }
      exportAllProjectList(param)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    handleChange(value) {
      //  Projectform.applyDeptId = value;
      let len = value.length;
      this.Projectform.applyDeptId = value[len - 1];
    },

    //获取子部门下拉列表数据
    getsubListData(deptId) {
      let reqParam = {
        deptId: deptId,
      };
      getsubDeptService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
  },
};
</script>
<style scoped >
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.ProgectMag {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  // background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
